<div class="relative overflow-x-hidden">
    <!--Navbar-->
    <div class="">
        <app-navbar></app-navbar>
    </div>
    <!-- Mat Spinner -->
    <ngx-spinner bdColor="rgba(256, 256, 256, 0.7)" size="default" color="#6eabc6" type="ball-spin-fade"
        [fullScreen]="true">
        <p style="color: black"> Please wait... </p>
    </ngx-spinner>
    <div class="relative home-wrapper">
        <div class="header pt-[160px] md:pt-[190px] pb-[70px] md:pb-[90px]">
            <!--Content before waves-->
            <div class="inner-header mt-[3em]">
                <h1 class="text-center uppercase font-medium">
                    Stay at Home<br />
                    {{homeText}}
                </h1>
                <div class="banner-links d-flex align-items-center justify-content-center mt-[50px]">
                    <a href="/doctors"
                        class="sigma_btn pointer bg-[#45a6d1] text-white py-[17px] px-[30px] inline-flex items-center rounded-[6px] hover:bg-[#112c76] ease-in duration-300"
                        tabindex="-1">
                        Find A Doctor
                        <span
                            class="material-symbols-outlined d-none d-sm-inline-block pl-[0.2em] text-[26px]">manage_search</span>
                    </a>
                    <a href="/about"
                        class="sigma_btn pointer bg-white text-[#00acb1] py-[17px] px-[30px] inline-flex items-center ml-4 rounded-[6px] hover:bg-[#112c76] ease-in duration-300"
                        tabindex="-1">
                        Read More
                        <span
                            class="material-symbols-outlined d-none d-sm-inline-block pl-[0.2em] text-[26px]">read_more</span>
                    </a>
                </div>
            </div>

            <!-- Top Banner Section Start -->
            <div class="search-bar-sec container mx-auto p-3 relative z-10 mt-8 md:mt-12">
                <div
                    class="relative bg-white text-black mx-auto p-[2em] border-t-8 border-[#45a6d1] rounded-lg  shadow-md w-full">
                    <div class="ai-booking-launcher">
                        <button type="button" (click)="openAiBooking()">
                            <span class="material-symbols-outlined">auto_awesome</span>
                            Book with AI assistant
                        </button>
                    </div>
                    <section class="appointment-assistant" aria-labelledby="appointment-request-title">
                            <!-- Header with AI Badge & Live Indicator -->
                            <div class="appointment-assistant-header">
                                <div class="assistant-title-area">
                                    <div class="assistant-icon-badge">
                                        <span class="material-symbols-outlined ai-sparkle-icon" aria-hidden="true">auto_awesome</span>
                                    </div>
                                    <div>
                                        <div class="flex items-center gap-2">
                                            <h3 id="appointment-request-title" class="assistant-title">AI Appointment Assistant</h3>
                                            <span class="ai-pill-tag">Smart Match</span>
                                        </div>
                                        <p class="assistant-subtitle">Describe what you need in plain words, and our AI will instantly find the right specialist.</p>
                                    </div>
                                </div>
                                <div class="assistant-status-pill hidden md:inline-flex">
                                    <span class="status-pulse-dot"></span>
                                    <span>AI Ready</span>
                                </div>
                            </div>

                            <!-- Modern Search Input Bar Capsule -->
                            <div class="ai-input-capsule">
                                <div class="capsule-icon-wrap">
                                    <span class="material-symbols-outlined capsule-search-icon">psychology</span>
                                </div>
                                <input type="text"
                                    class="ai-search-input"
                                    [(ngModel)]="appointmentRequest"
                                    [ngModelOptions]="{standalone: true}"
                                    maxlength="1000"
                                    (keyup.enter)="askAppointmentAssistant()"
                                    [disabled]="appointmentLoading"
                                    placeholder="e.g. “I need to see a skin doctor tomorrow evening”"
                                    aria-label="Describe your appointment needs" />
                                
                                <button *ngIf="appointmentRequest"
                                    type="button"
                                    class="ai-clear-btn"
                                    (click)="clearAppointmentRequest()"
                                    [disabled]="appointmentLoading"
                                    title="Clear">
                                    <span class="material-symbols-outlined text-[18px]">close</span>
                                </button>

                                <button type="button"
                                    class="ai-action-btn"
                                    (click)="askAppointmentAssistant()"
                                    [disabled]="appointmentLoading || !appointmentRequest.trim()"
                                    aria-label="Find specialists">
                                    <span *ngIf="!appointmentLoading" class="btn-content">
                                        <span class="btn-text">Find Doctor</span>
                                        <span class="material-symbols-outlined btn-arrow">arrow_forward</span>
                                    </span>
                                    <span *ngIf="appointmentLoading" class="btn-loading-spinner"></span>
                                </button>
                            </div>

                            <!-- Quick Suggestion Prompt Chips -->
                            <div class="ai-suggestions-bar">
                                <span class="suggestions-label">
                                    <span class="material-symbols-outlined text-[15px]">tips_and_updates</span>
                                    Try asking:
                                </span>
                                <div class="suggestion-chips-list">
                                    <button type="button"
                                        *ngFor="let suggestion of appointmentSuggestions"
                                        (click)="selectSuggestion(suggestion)"
                                        [disabled]="appointmentLoading"
                                        class="suggestion-chip">
                                        “{{ suggestion }}”
                                    </button>
                                </div>
                            </div>

                            <!-- Animated AI Loading Card -->
                            <div class="appointment-assistant-loading-card" *ngIf="appointmentLoading">
                                <div class="loading-wave-container">
                                    <div class="loading-pulse-orb">
                                        <span class="material-symbols-outlined animate-spin text-[20px]">sync</span>
                                    </div>
                                    <div class="loading-text-group">
                                        <div class="loading-heading">Analyzing your request...</div>
                                        <div class="loading-subtext">Extracting specialty, preferred date & matching verified doctors</div>
                                    </div>
                                </div>
                                <div class="loading-shimmer-bar">
                                    <div class="shimmer-fill"></div>
                                </div>
                            </div>

                            <!-- Error Alert Banner -->
                            <div class="appointment-assistant-error-banner" *ngIf="appointmentError" role="alert">
                                <span class="material-symbols-outlined text-[20px]">error_outline</span>
                                <div>{{ appointmentError }}</div>
                            </div>

                            <!-- Matched AI Results & Doctors -->
                            <div class="appointment-assistant-result-box" *ngIf="appointmentReply">
                                <div class="result-header">
                                    <div class="result-badge">
                                        <span class="material-symbols-outlined text-[16px]">check_circle</span>
                                        <span>AI Recommendation</span>
                                    </div>
                                </div>
                                <p class="result-message">{{ appointmentReply }}</p>

                                <!-- Extracted Parameters Tags -->
                                <div class="matched-tags-grid">
                                    <div class="tag-card tag-specialty" *ngIf="appointmentSpecialty">
                                        <span class="material-symbols-outlined tag-icon">medical_services</span>
                                        <div class="tag-details">
                                            <span class="tag-label">Specialty</span>
                                            <span class="tag-value">{{ appointmentSpecialty }}</span>
                                        </div>
                                    </div>
                                    <div class="tag-card tag-date" *ngIf="appointmentDate">
                                        <span class="material-symbols-outlined tag-icon">event</span>
                                        <div class="tag-details">
                                            <span class="tag-label">Requested Date</span>
                                            <span class="tag-value">{{ appointmentDate }}</span>
                                        </div>
                                    </div>
                                    <div class="tag-card tag-time" *ngIf="appointmentTimeOfDay">
                                        <span class="material-symbols-outlined tag-icon">schedule</span>
                                        <div class="tag-details">
                                            <span class="tag-label">Preferred Time</span>
                                            <span class="tag-value">{{ appointmentTimeOfDay | titlecase }}</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Recommended Specialists Section -->
                                <div *ngIf="doctors && doctors.length > 0" class="matched-doctors-container">
                                    <div class="matched-doctors-header">
                                        <div class="flex items-center gap-2">
                                            <span class="material-symbols-outlined text-[#112c76] text-[22px]">badge</span>
                                            <h4 class="text-[#112c76] font-bold text-lg m-0">Recommended Specialists</h4>
                                        </div>
                                        <span class="doctor-count-badge">{{ doctors.length }} Available</span>
                                    </div>

                                    <div class="grid grid-cols-12 gap-4 mt-4">
                                        <div class="col-span-12 md:col-span-6 xl:col-span-4" *ngFor="let doctor of doctors">
                                            <div class="doctor-card modern-doctor-card">
                                                <div class="doctor-details-container grid grid-cols-12 px-[15px] pt-[15px] pb-[15px] border border-[#e2edf6] rounded-t-[10px] bg-white">
                                                    <div class="doctor-img col-span-4 flex items-center justify-center relative">
                                                        <div class="w-[64px] h-[64px] rounded-full overflow-hidden p-0.5 border-2 border-[#45a6d1]/30 shadow-sm">
                                                            <img [src]="doctor.image !== 'https://medeaseadmin.onetikk.org/storage/' ? doctor.image : '/assets/images/icons/doctor-default-img.png'" [alt]="doctor.title" class="w-full h-full object-cover rounded-full">
                                                        </div>
                                                    </div>
                                                    <div class="doctor-description col-span-8">
                                                        <div class="doctor-description-inner ml-[10px]">
                                                            <div class="doctor-speciality flex mb-1.5">
                                                                <div class="speciality-badge">
                                                                    {{ doctor.specialty }}
                                                                </div>
                                                            </div>
                                                            <div class="doctor-title my-[3px] overflow-hidden text-black font-semibold">
                                                                <h4 class="text-[16px] font-bold text-[#112c76] m-0">{{ doctor.title }}</h4>
                                                            </div>
                                                            <div class="doctor-expertise flex items-center mt-1">
                                                                <span class="material-symbols-outlined text-[#45a6d1] text-[16px]">local_hospital</span>
                                                                <span class="text-[13px] text-[#5a7184] ml-1 max-w-[90%] whitespace-nowrap text-ellipsis overflow-hidden">
                                                                    {{ doctor.designation }}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="readmore-btn">
                                                    <button class="btn w-full text-[14px] font-bold text-white rounded-b-[10px] py-[10px] inline-flex items-center justify-center gap-1.5 doctor-book-btn" (click)="bookNow(doctor)">
                                                        <span>Book Appointment</span>
                                                        <span class="material-symbols-outlined text-[16px]">calendar_add_on</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="no-doctors-card" *ngIf="doctors && doctors.length === 0">
                                    <span class="material-symbols-outlined text-[36px] text-gray-400">person_search</span>
                                    <p class="font-medium text-gray-700 m-0">No matching doctors found for this specialty right now.</p>
                                    <p class="text-xs text-gray-500 m-0">Try searching another specialty or browse all doctors below.</p>
                                </div>
                            </div>
                        </section>
                        <form [formGroup]="searchForm" (ngSubmit)="search()">
                        <!-- Form Row -->
                        <div class="flex flex-wrap space-x-2 mb-6 mt-6 text-blavk">
                            <!-- Hospital Selection -->
                            <div class="flex-1" *ngIf="!isHospitalApp">
                                <mat-form-field class="w-full">
                                    <mat-label>Hospital</mat-label>
                                    <mat-select formControlName="branches"
                                        (selectionChange)="onHospitalSelectionChange($event.value)">
                                        <mat-option *ngFor="let hospital of hospitals"
                                            value="{{hospital.id}}">{{hospital.name}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>


                            <!-- Branch Selection -->
                            <div class="flex-1">
                                <mat-form-field class="w-full">
                                    <mat-label>Branch</mat-label>
                                    <mat-select formControlName="branches"
                                        (selectionChange)="onBranchSelectionChange($event.value)">
                                        <mat-option *ngFor="let branch of allBranches"
                                            value="{{branch.id}}">{{branch.name}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <!-- Department Selection -->
                            <div class="flex-1">
                                <mat-form-field class="w-full">
                                    <mat-label>Department</mat-label>
                                    <mat-select formControlName="specialities"
                                        (selectionChange)="onSpecialitySelectionChange($event.value)">
                                        <mat-option *ngFor="let speciality of allSpecialities"
                                            value="{{speciality.id}}">{{speciality.title}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <!-- Search Box -->
                            <div class="flex-1">
                                <!-- <mat-form-field class="w-full">
                                    <mat-label>Doctor Name</mat-label>
                                    <input type="text" matInput placeholder="" formControlName="doctorName"
                                        [(ngModel)]="doctorName">
                                </mat-form-field> -->
                                <mat-form-field class="w-[100%] example-full-width">
                                    <mat-label>Doctor Name</mat-label>
                                    <input type="text" matInput formControlName="doctorName" [matAutocomplete]="auto"
                                        [(ngModel)]="doctorName">
                                    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayDoctorFn"
                                        (optionSelected)="onDoctorSelection($event)">
                                        <mat-option *ngFor="let doctor of filteredDoctors | async" [value]="doctor">
                                            {{ doctor.title }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </div>
                            <div class="flex-1">
                                <button type="submit"
                                    class="w-[100%] bg-[#45a6d1] text-white py-[17px] px-[30px] inline-block rounded-[6px] hover:bg-[#112c76] ease-in duration-300 text-center cursor-pointer">
                                    Search</button>
                            </div>
                        </div>

                        <!-- Submit Button -->
                        <div class="flex justify-center">


                        </div>
                    </form>
                </div>
            </div>
            <!-- Top Banner Section End -->

            <!--Waves Container-->
            <!-- <div>
                <svg class="waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 24 150 28" preserveAspectRatio="none" shape-rendering="auto">
                    <defs>
                        <path id="gentle-wave"
                            d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
                    </defs>
                    <g class="parallax">
                        <use xlink:href="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.7" />
                        <use xlink:href="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.5)" />
                        <use xlink:href="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.3)" />
                        <use xlink:href="#gentle-wave" x="48" y="7" fill="#fff" />
                    </g>
                </svg>
            </div> -->
            <!--Waves end-->
        </div>
    </div>
    <!--Header ends-->
    <!-- Services Section Start -->
    <section class="services-sec pt-[6em] mt-0 md:mt-[4em] mb-[4em]">
        <div class="container mx-auto p-3 xxl:p-0" *ngIf="specialities">
            <div class="grid grid-cols-12 gap-6">
                <div class="col-span-12 sm:col-span-6 lg:col-span-4 xl:col-span-3"
                    *ngFor="let specialty of specialities;" (click)="gotoDoctorsList(specialty)">
                    <div class="service-card">
                        <div class="service-card-icon">
                            <span class="material-symbols-outlined text-[44px] text-[#45a6d1]">
                                health_and_safety
                            </span>
                        </div>
                        <div class="service-card-body">
                            <h5 class="mb-[1em] mt-0 text-[1.2em] text-[#112c76] font-medium uppercase">
                                {{specialty.title}}
                            </h5>
                            <!-- <p class="text-[#686a6f] text-[16px]">Lorem ipsum dolor sit amet consectetur adipisicing
                                elit, sed do eiusmod</p> -->
                            <button
                                class="font-medium  text-[#45a6d1] bg-transparent text-[1.2em] p-0 hover:text-[#677db9] cursor-pointer flex items-center"
                                (click)="gotoSpecialityDoctorsList(specialty)">
                                Find Doctors
                                <span class="material-symbols-outlined ml-4">
                                    trending_flat
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container mx-auto p-10 custom-border flex justify-center items-center"
            *ngIf="specialities && specialities.length === 0">
            <div class="flex justify-center">
                <p class="text-[#667ac3] text-center">
                    "Sorry, but we couldn't find any specialities in this field at the moment. Please
                    consider broadening your search criteria or checking back later.<br> If you have any specific
                    questions or need assistance, feel free to contact our support team. We're here to help!"
                </p>
            </div>
        </div>
        <div class="text-center">
            <button (click)="gotoSpecialities()"
                class="bg-[#45a6d1] text-white py-[17px] px-[30px] inline-block rounded-[6px] hover:bg-[#112c76] ease-in duration-300 text-center cursor-pointer"
                *ngIf="allSpecialities && allSpecialities.length > 3">
                View More
            </button>
        </div>
    </section>
    <!-- Services Section End -->
    <!-- Specialities Section Start -->
    <!-- <div class="speciality-sec dashboard-page-right container mx-auto lg:flex lg:items-center lg:justify-center sm:col-span-1 md:col-span-1 lg:col-span-1 relative py-[4em]">
        <div class="md:mb-5 xl:mb-0 custom-margin">
            <div class="mb-[50px] box_title">
                <h2 class="text-[25px] md:text-[30px] leading-[60px] font-normal mt-0">Specialities</h2>
            </div>
            <div class="mt-10">
                <div class="grid grid-cols-12 gap-4">
                    <div class="relative col-span-12 sm:col-span-6 lg:col-span-4 px-[15px] speciality-card"
                        *ngFor="let specialty of specialities;" (click)="gotoDoctorsList(specialty)">
                        <div class="speciality-card-inner">
                            <div class="relative overflow-hidden rounded-[30px] speciality-card-content">
                                <div class="relative speciality-card-img-wrapper">
                                    <div class="relative overflow-hidden speciality-card-img">
                                        <img src="/assets/images/service-01.jpg" alt=""
                                            class="w-full h-full object-cover rounded-[30px]">
                                    </div>
                                    <div
                                        class="speciality-icon hidden xl:block absolute bottom-[10px] right-[8px] rounded-full flex items-center justify-center p-[10px] text-white w-[40px] h-[40px]">
                                        <span
                                            class="material-symbols-outlined relative block">medical_information</span>
                                    </div>
                                </div>
                                <div class="absolute bottom-[40px] left-[40px] z-1 speciality-content-details">
                                    <button (click)="gotoSpecialityDoctorsList(specialty)"
                                        class="text-[22px] md:text-[28px] bg-transparent cursor-pointer hover:text-[#677db9] leading-[32px] max-w-[250px] m-0 text-white font-normal speciality-title">
                                        {{specialty.title}}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="error">
                    <div class="flex justify-center">
                        <h2>{{error}}</h2>
                    </div>
                </div>
            </div>
            <div (click)="gotoSpecialities()"
                class="viewmore-btn rounded-full borderfont-bold uppercase text-xs px-4 py-2 outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-15 p-2" *ngIf="allSpecialities.length > 3">
                View More
            </div>
        </div>
    </div> -->
    <!-- Specialities Section End -->
    <!-- Why Choose Us Section Start -->
    <section class="relative bg-opacity-90 video-banner-sec bg-[#112c76] pt-[70px]  md:pt-[135px] pb-[70px]">
        <div class="container mx-auto relative z-10">
            <div class="grid grid-cols-12 gap-4 items-center">
                <div class="col-span-12 sm:col-span-5">
                    <div class="p-6 video-banner-about">
                        <div class="mb-6 video-about-title">
                            <h3
                                class="text-[30px] md:text-[40px] lg:text-[60px] font-semibold text-white leading-[1.3em]">
                                Why Choose MedEase?
                            </h3>
                        </div>
                        <div class="video-about-content">
                            <p class="mb-[30px] text-white opacity-80 leading-[1.8em]">
                                Choosing Medease means choosing a more convenient, efficient, and patient-focused
                                healthcare
                                experience. Our platform is designed to make your healthcare journey smoother by
                                offering
                                reliable online appointment booking and access to top doctors, all from the comfort of
                                your
                                home.
                            <div class="flex mb-[30px] items-center">
                                <div>
                                    <span
                                        class="material-symbols-outlined text-white w-auto h-auto text-[44px] mr-[20px]">touch_app</span>
                                </div>
                                <div>
                                    <h5 class="text-white mb-[14px] text-[18px]">Convenience at Your Fingertips</h5>
                                    <p class="text-white opacity-80">Say goodbye to long queues and manual bookings.
                                        With
                                        Medease Stay at Home, you can schedule appointments at your preferred time,
                                        making
                                        healthcare more accessible and time-efficient.
                                    </p>
                                </div>
                            </div>
                            <div class="flex items-center">
                                <div>
                                    <span
                                        class="material-symbols-outlined text-white w-auto h-auto text-[44px] mr-[20px]">verified</span>
                                </div>
                                <div>
                                    <h5 class="text-white mb-[14px] text-[18px]">Trusted and Verified Doctors</h5>
                                    <p class="text-white opacity-80">We connect you with highly qualified and verified
                                        healthcare professionals, ensuring that you receive expert medical attention
                                        whenever you need it.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-span-12 sm:col-span-6">
                    <div class="video-img-sec relative w-[100%] h-[100%] ml-0 md:ml-[100px] p-6 md:p-0">
                        <div class="grid grid-cols-12 gap-4">
                            <div class="col-span-12 md:col-span-6">
                                <div class="w-[100%] md:w-[300px]">
                                    <img src="/assets/images/choose/choose-2.png" alt="" class="img-1">
                                    <div class="about-experience mt-4">
                                        <div class="about-experience-icon">
                                            <span
                                                class="material-symbols-outlined text-white w-auto h-auto text-[64px]">security</span>
                                        </div>
                                        <p class="text-start text-[#000]">Years Of <br> Quality Service</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-span-12 md:col-span-6 hidden lg:block">
                                <img src="/assets/images/choose/choose-3.png" alt="" class="img-2">
                                <img src="/assets/images/choose/choose-1.png" alt="" class="img-3 mt-4">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bg-[#45a6d1] py-8 mt-8 ml-20 relative z-10 bg-cover bg-center our-features"
                style="background-image: url('/assets/images/pattern-2.png');">
                <div class="grid grid-cols-2 md:grid-cols-4 gap-4 text-white">
                    <div class="text-center mb-[30px]">
                        <span
                            class="material-symbols-outlined text-white w-auto h-auto text-[54px] mr-[20px]">volunteer_activism</span>
                        <p class="mb-[20px]">Trusted Healthcare Partner</p>
                    </div>
                    <div class="text-center mb-[30px]">
                        <span
                            class="material-symbols-outlined text-white w-auto h-auto text-[54px] mr-[20px]">event_note</span>
                        <p class="mb-[20px]">Easy and Flexible Scheduling</p>
                    </div>
                    <div class="text-center mb-[30px]">
                        <span
                            class="material-symbols-outlined text-white w-auto h-auto text-[54px] mr-[20px]">key</span>
                        <p class="mb-[20px]">Safe and Secure Consultations</p>
                    </div>
                    <div class="text-center mb-[30px]">
                        <span
                            class="material-symbols-outlined text-white w-auto h-auto text-[54px] mr-[20px]">schedule</span>
                        <p class="mb-[20px]">Save Time and Avoid Crowds</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Why Choose Us Section End -->

    <!-- Hospitals Section Start -->
    <section class="solutions-sec mt-[220px] p-3 xxl:p-0" *ngIf="!isHospitalApp">
        <div class="container mx-auto">
            <div class="text-center mb-[50px]">
                <span class="subtitle inline-flex text-[#45a6d1] text-[16px] mb-[10px] font-medium">Your Partner in
                    Health</span>
                <h3 class="text-[60px] text-[#112c76] font-semibold mb-[20px] mt-0">Hospitals</h3>
            </div>

            <!-- Slider Section -->
            <div class="" *ngIf="hospitals && hospitals.length >0">
                <div class="grid grid-cols-12 gap-8">
                    <!-- Service Card 1 -->
                    <div class="col-span-12 sm:col-span-6 lg:col-span-4 xl:col-span-3 rounded-lg shadow-lg"
                        *ngFor="let hospital of hospitals">
                        <img src="/assets/images/hospital-cover.jpg" alt="Service Image"
                            class="w-full h-auto rounded-t-lg">
                        <div class="p-[30px]">
                            <h5 class="text-[1.2em] font-bold text-[#112c76] text-left mt-0 mb-0">
                                {{hospital.name}}
                            </h5>
                            <p class="mt-0 mb-[1em] text-[#686a6f]">
                                {{hospital.location}}
                            </p>
                            <!-- <p class="text-[#686a6f] text-[16px]">Lorem ipsum dolor sit amet consectetur adipisicing
                                elit, sed
                                do eiusmod Lorem ipsum dolor sit.</p> -->
                            <button type="button" (click)="gotoBranches(hospital.id)"
                                class="font-semibold  text-[#45a6d1] bg-transparent text-[1em] p-0 hover:text-[#677db9] cursor-pointer flex items-center">
                                View All Branches
                                <span class="material-symbols-outlined ml-4">
                                    trending_flat
                                </span>
                            </button>
                        </div>
                    </div>
                    <!-- Service Card 2 -->
                </div>
            </div>
        </div>
    </section>
    <!-- Hospitals Section End -->
    <!-- Branches Section Start -->
    <div class="pt-[4em] mt-[7em]" *ngIf="isHospitalApp">
        <div class="container mx-auto">
            <div class="hospital-branches-sec custom-margin">
                <div class="text-center mb-[50px]">
                    <span class="text-sm text-[#45a6d1] text-[16px] mb-[10px] font-medium">What We do</span>
                    <h3 class="text-[30px] md:text-[40px] lg:text-[60px] text-[#112c76] font-semibold mt-0 mb-[20px]">
                        Our Branches</h3>
                </div>
                <div class="" *ngIf="branches && branches.length > 0">
                    <div class="grid grid-cols-12 gap-4">
                        <div class="col-span-12 sm:col-span-6 lg:col-span-3 relative px-[15px] mb-[30px]"
                            *ngFor="let branch of branches">
                            <div class="absolute top-[15px] right-[25px] z-10 branch-icon-container">
                                <div
                                    class="bg-[#fff] text-[24px] p-[10px] rounded-full inline-block leading-1 text-center text-[#40739e] branch-icon">
                                    <span
                                        class="material-symbols-outlined w-[1em] h-[1em] relative block">home_health</span>
                                </div>
                            </div>
                            <div class="relative w-full h-full p-[45px] branch-details-container">
                                <div class="mb-[40px] pb-[30px] branch-title">
                                    <h5 class="text-white text-[22px] font-normal m-0">{{branch.name}}</h5>
                                </div>
                                <div class="px-6 pb-2">
                                    <button (click)="gotoDoctorsList(branch)" class="view-doctors">
                                        View All Doctors</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="error">
                    <div class="flex justify-center">
                        <h2>{{error}}</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Branches Section End -->
    <!-- Newsletter Section Start -->
    <section class="newsletter-sec py-[70px]  lg:py-[120px]">
        <div class="container mx-auto">
            <div class="grid grid-cols-12 gap-8">
                <div class="col-span-12 md:col-span-6 flex items-center h-[100%]">
                    <div
                        class="newsletter-left bg-[#112c76] lg:rounded-[6px] px-[20px] py-[80px] lg:px-[50px] flex items-center h-[100%]">
                        <div class="">
                            <div class="flex items-center">
                                <!-- <span class="material-symbols-outlined text-[70px] inline-block mr-[30px] text-white">
                                mark_email_unread
                            </span> -->
                                <h4
                                    class="text-[30px] md:text-[40px] lg:text-[60px] font-semibold text-white leading-[1.3em] mb-[20px]">
                                    Experience Our Solution in Action – Book a Free Demo
                                </h4>
                            </div>
                            <p class="text-white text-[1.1em] mt-[20px] mb-[35px] max-w-[75%]">
                                See how medease can transform your appointment system and boost efficiency! Schedule a
                                personalized demo with our experts to explore the features tailored to your needs.
                            </p>
                            <a href="mailto:sales@onetikk.com" type="button"
                                class="light bg-white text-[#112c76] font-semibold rounded-[6px] py-[14px] px-[30px] hover:bg-[#45a6d1] ease-in duration-300 hover:text-white cursor-pointer inline-flex items-center">
                                <span class="material-symbols-outlined text-[#112c76] mr-2">event_available</span>
                                Book a Demo
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-span-12 md:col-span-6">
                    <div class="newsletter-right bg-[#fff] h-[100%] flex items-center justify-center">
                        <div class="grid grid-cols-12">
                            <div class="col-span-12">
                                <div
                                    class="clients-img border border-[#ebf2f3] flex items-center justify-center p-[5px] overflow-hidden mb-[30px] rounded-[15px]">
                                    <img src="/assets/images/banners/banner-3.png" alt="" class="rounded-[15px]">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Newsletter Section End -->
    <!-- Process Section Start -->
    <section class="process-sec px-3 xxl:px-0 pb-[70px] lg:py-[120px] relative">
        <div class="container mx-auto">
            <div class="grid grid-cols-12">
                <div class="col-span-12 lg:col-span-5">
                    <div class="process-title">
                        <span class="subtitle inline-flex text-[#45a6d1] text-[16px] mb-[10px] font-medium">Book.
                            Confirm.
                            Attend</span>
                        <h3 class="title my-0 font-bold text-[30px] md:text-[40px] lg:text-[60px] text-[#112c76]">How it
                            Works?</h3>
                    </div>
                </div>
                <div class="col-span-12 lg:col-span-4">
                    <p class="mb-0 max-w-[90%]">
                        MedEase offers a simple and efficient way to book doctor appointments online. Easily browse
                        available doctors, select a convenient time, and confirm your appointment—all from the comfort
                        of
                        your home. Enjoy a seamless experience designed for your health and convenience.
                    </p>
                </div>
                <div class="col-span-12 lg:col-span-3 my-4 lg:my-0">
                    <a href="/doctors"
                        class="bg-[#45a6d1] text-white inline-block text-14px font-medium py-[17px] px-[30px] rounded-[6px] hover:bg-[#112c76] ease-in duration-300">Visit
                        Doctors</a>
                </div>
            </div>
            <div class="grid grid-cols-12 gap-4 relative process-solution-container mt-[2em]">
                <div class="col-span-12 lg:col-span-4">
                    <div class="process-solution mb-[30px] flex">
                        <div class="process-icon">
                            <span
                                class="w-[110px] h-[110px] bg-[#fff] rounded-[6px] shadow-[0_0_10px_5px_rgba(0,0,0,0.03)] mr-[28px] text-[#45a6d1] text-[20px] flex items-center justify-center">
                                <span class="material-symbols-outlined text-[56px]">search</span>
                            </span>
                        </div>
                        <div class="process-description">
                            <h5 class="mt-0 lg:mb-[5px] text-black text-[20px] font-medium">Search for Doctors</h5>
                            <p class="mb-0 ">
                                Browse through our extensive list of experienced qualified doctors. Our user-friendly
                                search
                                feature helps you find the right healthcare provider quickly.
                            </p>
                            <span class="text-[18px] block font-medium text-[#45a6d1] my-[18px]">Step 1</span>
                            <span
                                class="pulsive-dot relative inline-block w-[12px] h-[12px] rounded-full bg-[#45a6d1] ml-[6px]"></span>
                        </div>
                    </div>
                </div>
                <div class="col-span-12 lg:col-span-4">
                    <div class="process-solution mb-[30px] flex">
                        <div class="process-icon">
                            <span
                                class="w-[110px] h-[110px] bg-[#fff] rounded-[6px] shadow-[0_0_10px_5px_rgba(0,0,0,0.03)] mr-[28px] text-[#45a6d1] text-[20px] flex items-center justify-center">
                                <span class="material-symbols-outlined text-[56px]">calendar_month</span>
                            </span>
                        </div>
                        <div class="process-description">
                            <h5 class="mt-0 lg:mb-[5px] text-black text-[20px] font-medium">Select Your Appointment</h5>
                            <p class="mb-0 ">
                                Choose a suitable date and time from the available slots. With just a few clicks, you
                                can
                                book your appointment seamlessly without any hassle.
                            </p>
                            <span class="text-[18px] block font-medium text-[#45a6d1] my-[18px]">Step 2</span>
                            <span
                                class="pulsive-dot relative inline-block w-[12px] h-[12px] rounded-full bg-[#45a6d1] ml-[6px]"></span>
                        </div>
                    </div>
                </div>
                <div class="col-span-12 lg:col-span-4">
                    <div class="process-solution mb-[30px] flex">
                        <div class="process-icon">
                            <span
                                class="w-[110px] h-[110px] bg-[#fff] rounded-[6px] shadow-[0_0_10px_5px_rgba(0,0,0,0.03)] mr-[28px] text-[#45a6d1] text-[20px] flex items-center justify-center">
                                <span class="material-symbols-outlined text-[56px]">verified_user</span>
                            </span>
                        </div>
                        <div class="process-description">
                            <h5 class="mt-0 lg:mb-[5px] text-black text-[20px] font-medium">Confirm and Attend</h5>
                            <p class="mb-0 ">
                                Once your appointment is booked, you’ll receive a confirmation via email. Simply
                                arrive at your chosen hospital or clinic on the scheduled date for your consultation.
                            </p>
                            <span class="text-[18px] block font-medium text-[#45a6d1] my-[18px]">Step 3</span>
                            <span
                                class="pulsive-dot relative inline-block w-[12px] h-[12px] rounded-full bg-[#45a6d1] ml-[6px]"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Process Section End -->
    <!-- Our Doctors Section Start -->
    <section class="our-doctors-sec px-3 md:px-0">
        <div class="container mx-auto">
            <div class="doctors-sec-title text-center mb-[50px]">
                <span class="subtitle text-[#45a6d1] inline-flex text-[16px] font-medium mb-[10px]">Meet Our Team</span>
                <h3 class="title text-[#112c76] font-bold text-[30px] md:text-[40px] lg:text-[60px] mt-0 mb-[20px]">Find
                    The Best Doctors</h3>
            </div>
            <div *ngIf="doctors && doctors.length >0">
                <div class="grid grid-cols-12 gap-4">
                    <div class="col-span-12 md:col-span-6 xl:col-span-4" *ngFor="let doctor of doctors">
                        <div class="doctor-card p-2">
                            <div
                                class="doctor-details-container grid grid-cols-12 px-[29px] pt-[29px] pb-[30px] rounded-top-5px border border-[#e8e8e8] rounded-t-[5px]">
                                <div class="doctor-img col-span-4">
                                    <a href="#"
                                        class="inline-block w-[80px] h-[80px] lg:w-[100px] lg:h-[100px] rounded-full overflow-hidden">
                                        <img [src]="doctor.image !== 'https://medeaseadmin.onetikk.org/storage/' ? doctor.image : '/assets/images/icons/doctor-default-img.png'"
                                            alt="" class="w-[100%] h-[100%] object-cover">
                                    </a>
                                </div>
                                <div class="doctor-description col-span-8">
                                    <div class="doctor-description-inner ml-[10px]">
                                        <div class="doctor-speciality flex">
                                            <div
                                                class="speciality-title py-[3px] px-[14px] text-[14px] border border-[#e8e8e8] rounded-[5px] text-[#45a6d1]">
                                                {{doctor.specialty}}
                                            </div>
                                            <!-- <div
                                                class="doctor-rating py-[3px] px-[16px] bg-[#112c76] text-white rounded-[5px] ml-[10px] text-[14px]">
                                                <span>(124)</span>
                                            </div> -->
                                        </div>
                                        <div
                                            class="doctor-title text-18px md:text-[20px] lg:text-[24px] my-[10px] overflow-hidden text-black font-semibold">
                                            <h4 class="mb-2 font-medium text-[#112c76]">{{doctor.title}}</h4>
                                        </div>
                                        <div
                                            class="doctor-expertise flex items-center text-[14px] text-[#112c76b5] flex text-[14px] text-[#858585]">
                                            <span class="material-symbols-outlined overflow-hidden text-[#112c76b5]">
                                                school
                                            </span>
                                            <span
                                                class="text-[16px] text-[#858585] relative py-[0.5em] pl-[1em] max-w-[90%] whitespace-nowrap text-ellipsis overflow-hidden">
                                                {{doctor.qualification}}</span>
                                        </div>
                                        <div
                                            class="doctor-expertise flex items-center text-[14px] text-[#112c76b5] mb-[10px] text-[#858585]">
                                            <span class="material-symbols-outlined text-[#112c76b5]">
                                                local_hospital
                                            </span>
                                            <span
                                                class="text-[16px] text-[#686a6f] relative py-[0.5em] pl-[1em] max-w-[90%] whitespace-nowrap text-ellipsis overflow-hidden">
                                                {{doctor.designation}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="readmore-btn">
                                <button
                                    class="btn w-[100%] text-[16px] font-bold bg-[#112c76] text-white rounded-b-[5px]  py-[5px] px-[35px] inline-flex text-center leading-[40px] justify-center hover:bg-[#45a6d13b] hover:text-[#112c76] ease-in duration-300 cursor-pointer"
                                    (click)="bookNow(doctor)">
                                    Book An Appointment
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-10 custom-border flex justify-center items-center" *ngIf="doctors && doctors.length === 0">
                <div class="flex justify-center">
                    <p class="text-[#667ac3] text-center">
                        "Sorry, but we couldn't find any doctors specializing in this field at the moment. Please
                        consider broadening your search criteria or checking back later.<br> If you have any specific
                        questions or need assistance, feel free to contact our support team. We're here to help!"
                    </p>
                </div>
            </div>
            <div *ngIf="error && !doctors">
                <div class="flex justify-center">
                    <h2>{{error}}</h2>
                </div>
            </div>
            <div class="text-center mt-[2em]">
                <button *ngIf="doctors && showBtn" (click)="gotoDoctorsList()"
                    class="bg-[#45a6d1] text-white py-[17px] px-[30px] inline-block rounded-[6px] hover:bg-[#112c76] ease-in duration-300 text-center cursor-pointer">
                    View All Doctors</button>
            </div>
        </div>
    </section>
    <!-- Our Doctors Section End -->
    <!-- Doctors Section End -->
    <!-- <div class="container mx-auto md:mb-5 xl:mb-0">
        Mat Spinner 
        <ngx-spinner bdColor="rgba(256, 256, 256, 0.7)" size="default" color="#6eabc6" type="ball-spin-fade"
            [fullScreen]="true">
            <p style="color: black"> Please wait... </p>
        </ngx-spinner>

        <div class="custom-margin doctor-list-sec mb-[3em]">
            <div class="mb-[50px] box_title">
                <h2 class="text-[25px] md:text-[30px] leading-[60px] font-normal">Find the best Doctors</h2>
                <p>The online appointment is more reliable than manual or without appointment visit to the doctor</p>
            </div>
            <div class="" *ngIf="doctors && doctors.length >0">
                <div class="grid grid-cols-12 gap-4">
                    <div class="col-span-12 sm:col-span-6 lg:col-span-4 xl:col-span-3 px-[15px]"
                        *ngFor="let doctor of doctors">
                        <div class="relative overflow-hidden">
                            <div class="relative overflow-hidden rounded-[30px]" id="doctor-profile-card">
                                <div class="doctor-img-wrapper">
                                    <div class="doctor-img">
                                        <img class="w-full h-[450px] sm:h-[400px] rounded-[30px] object-cover object-top"
                                            [src]="doctor.image !== 'https://medeaseadmin.onetikk.org/storage/' ? doctor.image : '/assets/images/icons/doctor-default-img.png'" alt="{{doctor.title}}">
                                    </div>
                                </div>
                                <div class="pt-[22px] doctor-details-content">
                                    <div class="px-6 doctor-details-inner">
                                        <div
                                            class="inline-block text-[12px] leading-[28px] uppercase pl-[15px] relative tracking-2 doctor-position">
                                            {{doctor.specialty}}</div>
                                        <h3 class="text-[24px] leading-[24px] mt-2 text-[#010d27] doctor-title">
                                            {{doctor.title}}</h3>
                                    </div>
                                    <div class="px-6 pb-2">
                                        <button (click)="bookNow(doctor)"
                                            class="book-now w-full rounded-md borderfont-bold uppercase text-xs px-4 py-3 outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-15 p-2 cursor-pointer">
                                            Book Now</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-10 custom-border flex justify-center items-center" *ngIf="doctors && doctors.length === 0">
                <div class="flex justify-center">
                    <p class="text-[#667ac3] text-center">
                        "Sorry, but we couldn't find any doctors specializing in this field at the moment. Please
                        consider broadening your search criteria or checking back later.<br> If you have any specific
                        questions or need assistance, feel free to contact our support team. We're here to help!"
                    </p>
                </div>
            </div>
            <div *ngIf="error && !doctors">
                <div class="flex justify-center">
                    <h2>{{error}}</h2>
                </div>
            </div>
            <div *ngIf="doctors && showBtn" (click)="gotoDoctorsList()"
                class="viewmore-btn rounded-full borderfont-bold uppercase text-xs p-[1.5em] outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-15 p-2">
                View More</div>
        </div>

    </div> -->
    <!-- Doctors Section End -->

    <!-- Hospital Section Start -->
    <!-- <div class="py-[4em] bg-[#f0f2f8]" *ngIf="!isHospitalApp">
        <div class="container mx-auto">
            <div class="hospital-branches-sec custom-margin">
                <div class="mb-[50px] box_title">
                    <h2 class="text-[25px] md:text-[30px] leading-[60px] font-normal mt-0">Hospitals</h2>
                    <p>Leading Healthcare Providers. Trust us for Business</p>
                </div>
                <div class="" *ngIf="hospitals && hospitals.length >0">
                    <div class="grid grid-cols-12 gap-4">
                        <div class="col-span-12 sm:col-span-6 xl:col-span-3 relative px-[15px] mb-[30px]"
                            *ngFor="let hospital of hospitals">
                            <div class="absolute top-[15px] right-[25px] z-10 branch-icon-container">
                                <div
                                    class="bg-[#fff] text-[24px] p-[10px] rounded-full inline-block leading-1 text-center text-[#40739e] branch-icon">
                                    <span
                                        class="material-symbols-outlined w-[1em] h-[1em] relative block">home_health</span>
                                </div>
                            </div>
                            <div class="relative w-full h-full p-[45px] branch-details-container">
                                <div class="mb-[40px] pb-[30px] branch-title">
                                    <h5 class="text-white text-[22px] font-normal m-0">{{hospital.name}}</h5>
                                </div>
                                <div class="px-6 pb-2">
                                    <button (click)="gotoBranches(hospital.id)" class="view-doctors">
                                        View All Branches</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <!-- Hospital Section End -->

    <!-- Appointment Process Section Start -->
    <!-- <div class="relative bg-[#f1f9ff] text-center process-style-two">        
        <div class="static px-[15px] mx-auto auto-container">
            <div class="sec-title text-center relative block mb-[30px]">
                <p class="mb-0 text-[#475569] relative inline-block text-[17px] font-bold uppercase pb-[17px]">Process
                </p>
                <h2 class="mt-0 mb-10 relative block font-black text-black">Appointment Process</h2>
            </div>
            <div class="relative inner-content">
                <div
                    class="arrow absolute left-[270px] top-[65px] w-[650px] h-[51px] bg-[url('/assets/images/arrow-1.png')] bg-cover bg-no-repeat bg-center hidden lg:block">
                </div>
                <div class="grid grid-cols-1 lg:grid-cols-12 gap-4">
                    <div class="col-12 md:col-span-6 lg:col-span-4 processing-block">
                        <div class="processing-block-two">
                            <div class="relative block px-[50px] inner-box">
                                <figure
                                    class="relative mx-auto flex justify-center items-center w-[200px] h-[200px] bg-[#fff] rounded-[70px] mb-[33px] icon-box">
                                    <img src="/assets/images/online-doctor-icon.png" alt="">
                                </figure>
                                <h3 class="text-[#475569] relative block text-2xl font-bold">Search Best <br>Online
                                    Doctors</h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 md:col-span-6 lg:col-span-4 processing-block">
                        <div class="processing-block-two">
                            <div class="relative block px-[50px] inner-box">
                                <figure
                                    class="relative mx-auto flex justify-center items-center w-[200px] h-[200px] bg-[#fff] rounded-[70px] mb-[33px] icon-box">
                                    <img src="/assets/images/doctor-profile-icon.png" alt="">
                                </figure>
                                <h3 class="text-[#475569] relative block text-2xl font-bold">View Doctor<br> Profile
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 md:col-span-6 lg:col-span-4 processing-block">
                        <div class="processing-block-two">
                            <div class="relative block px-[50px] inner-box">
                                <figure
                                    class="relative mx-auto flex justify-center items-center w-[200px] h-[200px] bg-[#fff] rounded-[70px] mb-[33px] icon-box">
                                    <img src="/assets/images/doctor-appointment-icon.png" alt="">
                                </figure>
                                <h3 class="text-[#475569] relative block text-2xl font-bold">Get Instant Doctor
                                    Appoinment</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
    <!-- Appointment Process Section End -->

    <!-- Home About Section Start -->
    <!-- <section class="home-about-sec py-[100px] bg-[#f0f2f8] mt-[100px]"></section> -->
    <section class="home-about-sec py-[70px] lg:py-[100px] mt-0 lg:mt-[100px]">
        <div class="container mx-auto">
            <div class="grid grid-cols-12 items-center">
                <div class="col-span-12 lg:col-span-6">
                    <div class="home-about-left p-[30px]">
                        <img src="/assets/images/home-about.webp" alt="" class="w-[100%]">
                    </div>
                </div>
                <div class="col-span-12 lg:col-span-6 p-3 xxl:p-0">
                    <div class="home-about-title mb-[50px]">
                        <span class="subtitle text-[#45a6d1] inline-flex text-[16px] font-medium mb-[10px]">About
                            Medease</span>
                        <h3
                            class="title text-[#112c76] font-bold text-[30px] md:text-[40px] lg:text-[60px] mt-0 mb-[20px]">
                            Find Care Doctor And Hospital
                            At Your Fingertips.</h3>
                    </div>
                    <div class="home-about-content">
                        <p class="mb-[10px]">
                            We believe that accessing healthcare should be effortless and efficient. Our platform
                            connects
                            you with a wide network of qualified doctors and hospitals, making it easy to find the care
                            you
                            need at your fingertips. Whether you're seeking a routine check-up or specialized treatment,
                            Medease is here to simplify your healthcare journey and ensure you receive the best possible
                            care.
                        </p>
                        <p>
                            Medease is dedicated to transforming the way you access healthcare. With our intuitive
                            platform,
                            you can quickly search for healthcare providers, read reviews, and book appointments that
                            fit
                            your schedule. We prioritize your health and well-being by providing a seamless experience
                            that
                            puts quality care just a click away.
                        </p>
                        <div class="grid grid-cols-12">
                            <div class="col-span-12 md:col-span-6">
                                <div class="home-about-features py-[10px] px-[25px]">
                                    <div class="home-about-features-icon">
                                        <span class="material-symbols-outlined text-[25px]">
                                            medical_services
                                        </span>
                                    </div>
                                    <div class="about-feature-content">
                                        <h3 class="box-title text-[20px] font-semibold text-[#112c76] mb-0">
                                            Find Special Doctor
                                        </h3>
                                        <p class="box-description text-[18px] font-normal text-[#858585] mt-0">Book an
                                            appointment</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-span-12 md:col-span-6">
                                <div class="home-about-features py-[10px] px-[25px]">
                                    <div class="home-about-features-icon">
                                        <span class="material-symbols-outlined text-[25px]">
                                            medical_information
                                        </span>
                                    </div>
                                    <div class="about-feature-content">
                                        <h3 class="box-title text-[20px] font-semibold text-[#112c76] mb-0">
                                            Health Laboratory
                                        </h3>
                                        <p class="box-description text-[18px] font-normal text-[#858585] mt-0">Available
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-span-12 md:col-span-6">
                                <div class="home-about-features py-[10px] px-[25px]">
                                    <div class="home-about-features-icon">
                                        <span class="material-symbols-outlined text-[25px]">
                                            support_agent
                                        </span>
                                    </div>
                                    <div class="about-feature-content">
                                        <h3 class="box-title text-[20px] font-semibold text-[#112c76] mb-0">
                                            Consult Online 24/7
                                        </h3>
                                        <p class="box-description text-[18px] font-normal text-[#858585] mt-0">Best
                                            Solution
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-span-12 md:col-span-6">
                                <div class="home-about-features py-[10px] px-[25px]">
                                    <div class="home-about-features-icon">
                                        <span class="material-symbols-outlined text-[25px]">
                                            ambulance
                                        </span>
                                    </div>
                                    <div class="about-feature-content">
                                        <h3 class="box-title text-[20px] font-semibold text-[#112c76] mb-0">
                                            Ambulance Service
                                        </h3>
                                        <p class="box-description text-[18px] font-normal text-[#858585] mt-0">Book an
                                            ambulance</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Home About Section End -->

    <!-- Banner Section Start -->
    <!-- <div class="container mx-auto p-10">
        <div class="p-[4em] lg:p-[8em] home-box">
            <h1 class="m-0 text-xl md:text-3xl"> Book appointments with minimum wait-time & verified doctor details</h1>
            <p class="m-0 text-lg md:text-2xl">Leading Healthcare Providers.
                Trust us for Business</p>
        </div>
    </div> -->
    <!-- Banner Section End -->

</div>

<app-message></app-message>
<app-footer></app-footer>
